// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import styles from "../CommonStyles/commonstyles.module.scss";
// import noImageFound from "../../../../assets/images/extras/noImgFound.png";
// import uploadedImage from "../../../../assets/images/svg/noData.png";
// import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
// import { useDispatch, useSelector } from "react-redux";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import {
//   useRemoveService,
//   useFetchAllServices,
// } from "../../../../hooks/partnerHook/usePartnerService";
// import { updateServicesData } from "../../../../store/Partner/partnerDataSlice";

// const Services = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const userData = useSelector((state) => state.partner.user);
//   const partnerId = userData?.partner?.id;

//   const {
//     data: servicesData,
//     isPending,
//     isError,
//   } = useFetchAllServices(partnerId);

//   const {
//     mutate: removeServiceHook,
//     isSuccess: serviceDeleted,
//     isError: deletionError,
//   } = useRemoveService();

//   const [services, setServices] = useState([]);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteName, setDeleteName] = useState("");

//   useEffect(() => {
//     if (servicesData) {
//       dispatch(updateServicesData(servicesData));
//     }
//   }, [dispatch, servicesData]);

//   const savedServices = useSelector((state) => state.partner.services);
//   useEffect(() => {
//     if (savedServices) {
//       setServices(savedServices);
//     }
//   }, [savedServices]);

//   const handleDelete = () => {
//     if (deleteId) {
//       removeServiceHook({ partnerId, serviceId: deleteId });
//       setShowDeleteModal(false);
//     }
//   };

//   const handleNavigateToDetails = (serviceId) => {
//     navigate(`/dashboard/services/${serviceId}`);
//   };

//   if (isPending) {
//     return <h2>Loading...</h2>;
//   }

//   if (isError) {
//     return <h2>Error! Please refresh and try again.</h2>;
//   }

//   return (
//     <div className={styles.dashboardContainer}>
//       <h2 className={styles.browseEquipmentsTitle}>Browse All Services</h2>

//       {services.length > 0 ? (
//         <div className={styles.dashboardGridContainer}>
//           {services.map((service) => (
//             <div
//               key={service.service_id}
//               className={styles.dashboardCardWrapper}
//               onClick={() => handleNavigateToDetails(service.service_id)}
//             >
//               <div className={styles.dashboardCard}>
//                 <div className={styles.dashboardCardImageContainer}>
//                   <img
//                     src={
//                       service.media.length > 0
//                         ? service.media[0].media_url
//                         : noImageFound
//                     }
//                     alt={service.title}
//                     className={styles.droneCardImg}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = noImageFound;
//                     }}
//                   />
//                 </div>
//                 <div className={styles.dashboardCardBody}>
//                   <div className={styles.dashboardCardStack}>
//                     {/* <h5 className={styles.dashboardCardCategoryButton}>
//                       {service.sub_category?.category?.category_name ||
//                         "Fetching..."}
//                     </h5> */}
//                     <h5 className={styles.dashboardCardVerifiedButton}>
//                       {service.verification_status === "verified"
//                         ? "Verified"
//                         : "Not Verified"}
//                     </h5>
//                   </div>
//                   <div className={styles.equipmentHeader}>
//                     <h5 className={styles.dashboardCardCategoryTitle}>
//                       {service.title || "Fetching..."}
//                     </h5>
//                     <RiDeleteBin5Line
//                       className={styles.deleteIcon}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setDeleteId(service.service_id);
//                         setDeleteName(service.title);
//                         setShowDeleteModal(true);
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className={styles.noDataSection}>
//           <img
//             src={uploadedImage}
//             alt="No Data"
//             className={styles.noDataImage}
//           />

//           <h4 className={styles.noEquipmentText}>No services added</h4>

//           <p className={styles.noEquipmentDescription}>
//             Specify the types of drone services you provide (e.g., photography,
//             inspection, mapping and surveillance).
//           </p>
//         </div>
//       )}

//       {showDeleteModal && (
//         <DeleteBox
//           deleteFunction={handleDelete}
//           isSuccess={serviceDeleted}
//           isError={deletionError}
//           contentName={deleteName}
//           setShowDeleteModal={setShowDeleteModal}
//         />
//       )}
//     </div>
//   );
// };

// export default Services;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../CommonStyles/commonstyles.module.scss";
import noImageFound from "../../../../assets/images/extras/noImgFound.png";
import uploadedImage from "../../../../assets/images/svg/noData.png";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useDispatch, useSelector } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import {
  useRemoveService,
  useFetchAllServices,
} from "../../../../hooks/partnerHook/usePartnerService";
import { updateServicesData } from "../../../../store/Partner/partnerDataSlice";

const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.partner.user);
  const partnerId = userData?.partner?.id;

  const {
    data: servicesData,
    isPending,
    isError,
    error, // Add error for better debugging
  } = useFetchAllServices(partnerId);

  const {
    mutate: removeServiceHook,
    isSuccess: serviceDeleted,
    isError: deletionError,
    isPending: isDeleting, // Add isPending to show deletion progress
  } = useRemoveService();

  const [services, setServices] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  useEffect(() => {
    if (servicesData) {
      dispatch(updateServicesData(servicesData));
      setServices(servicesData); // Update local state directly
    }
  }, [dispatch, servicesData]);

  const handleDelete = () => {
    if (deleteId) {
      removeServiceHook(
        { partnerId, serviceId: deleteId },
        {
          onSuccess: () => {
            setShowDeleteModal(false);
            setDeleteId(null);
            setDeleteName("");
          },
        }
      );
    }
  };

  const handleNavigateToDetails = (serviceId) => {
    navigate(`/dashboard/services/${serviceId}`);
  };

  if (isPending || isDeleting) {
    return <h2>Loading...</h2>;
  }

  if (isError) {
    return <h2>Error: {error?.message || "Please refresh and try again."}</h2>;
  }

  return (
    <div className={styles.dashboardContainer}>
      <h2 className={styles.browseEquipmentsTitle}>Browse All Services</h2>

      {services.length > 0 ? (
        <div className={styles.dashboardGridContainer}>
          {services.map((service) => (
            <div
              key={service.service_id}
              className={styles.dashboardCardWrapper}
              onClick={() => handleNavigateToDetails(service.service_id)}
            >
              <div className={styles.dashboardCard}>
                <div className={styles.dashboardCardImageContainer}>
  {service.media?.length > 0 && (() => {
    const mediaUrl = service.media[0].media_url;
    const isVideo = /\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv|m4v)$/i.test(mediaUrl.toLowerCase());

    return isVideo ? (
      <video
        src={mediaUrl}
        controls
        className={styles.droneCardImg}
      />
    ) : (
      <img
        src={mediaUrl}
        alt={service.title}
        className={styles.droneCardImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImageFound;
        }}
      />
    );
  })()}
</div>

                <div className={styles.dashboardCardBody}>
                  <div className={styles.dashboardCardStack}>
                    <h5 className={styles.dashboardCardVerifiedButton}>
                      {service.verification_status === "verified"
                        ? "Verified"
                        : "Not Verified"}
                    </h5>
                  </div>
                  <div className={styles.equipmentHeader}>
                    <h5 className={styles.dashboardCardCategoryTitle}>
                      {service.title || "Fetching..."}
                    </h5>
                    <RiDeleteBin5Line
                      className={styles.deleteIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteId(service.service_id);
                        setDeleteName(service.title);
                        setShowDeleteModal(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noDataSection}>
          <img
            src={uploadedImage}
            alt="No Data"
            className={styles.noDataImage}
          />
          <h4 className={styles.noEquipmentText}>No services added</h4>
          <p className={styles.noEquipmentDescription}>
            Specify the types of drone services you provide (e.g., photography,
            inspection, mapping and surveillance).
          </p>
        </div>
      )}

      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={serviceDeleted}
          isError={deletionError}
          contentName={deleteName}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

export default Services;
